export const getAllXPaths = (spec: any[], parentPath = ''): string[] => {
  let paths: string[] = []
  spec.forEach((component, index) => {
    const currentPath = parentPath ? `${parentPath}.${index}` : `${index}`
    paths.push(currentPath)
    if (component.children && component.children.length > 0) {
      paths = paths.concat(getAllXPaths(component.children, currentPath))
    }
  })
  return paths
}
